import { SafeStyle } from '@angular/platform-browser';
import { Injectable } from "@angular/core";

import { HrPscType, HrEmployeeStatus } from '../../../../models';

// PscTypeId
const EMPLOYEE_STATUS: number = 1;

//UnionAffiliationId
const NO_REPRESENTATION: number = 4;

@Injectable()
export class PscFunctions {

  colorCodeDate(checkDate: Date, accepted: boolean, rejected: boolean) {
    let effectiveDate = new Date(checkDate);
    let result = 'transparent';
    let today = new Date();
    let ret = {};

    if (effectiveDate <= today && !(accepted || rejected)) {
      result = '#33FFB2';
    }
    else {
      result = 'transparent';
    }

    ret['background-color'] = result;
    return ret;
  }

  colorCodeNumber(checkNumber: number) {
    let result = 'transparent';
    let ret = {};

    if (checkNumber <= 0) {
      result = 'red';
    }
    else {
      result = 'black';
    }

    ret['color'] = result;
    return ret;
  }


  colorRequiredStatus(column: string, columnValue: string, pscTypeId: number, esTypeId: number, unionId: number, allPscTypes: HrPscType[], allEmployeeStatuses: HrEmployeeStatus[]): SafeStyle {
    let result = 'transparent';

    if (allPscTypes.length > 0 && allEmployeeStatuses.length > 0 && pscTypeId != null) {
      let pscType = allPscTypes.filter(pt => pt.pscTypeId == pscTypeId)[0];
      let isRequired: boolean = false;

      if (pscTypeId == EMPLOYEE_STATUS) {
        let empStatus = allEmployeeStatuses.filter(es => es.employeeStatusId == esTypeId)[0];
        switch (column) {
          case 'HR':
            isRequired = (pscType.hrAuditRequired && empStatus.hrAuditRequired);
            break;
          case 'WS':
            isRequired = (pscType.wsLeadReviewRequired && empStatus.wsLeadReviewRequired);
            break;
          case 'DM':
            isRequired = (pscType.dmApprovalRequired && empStatus.dmApprovalRequired);
            break;
          case 'PMM':
            isRequired = (pscType.pmmApprovalRequired && empStatus.pmmApprovalRequired);
            break;
          case 'HRM':
            isRequired = (pscType.hrmApprovalRequired && empStatus.hrmApprovalRequired);
            break;
          case 'ACCT':
            isRequired = (pscType.acctReceivalRequired && empStatus.acctReceivalRequired);
            break;
          case 'IT':
            isRequired = (pscType.itReceivalRequired && empStatus.itReceivalRequired);
            break;
          default:
            isRequired = false;
            break;
        }

      }
      else {
        switch (column) {
          case 'HR':
            isRequired = pscType.hrAuditRequired;
            break;
          case 'WS':
            isRequired = pscType.wsLeadReviewRequired;
            break;
          case 'DM':
            isRequired = pscType.dmApprovalRequired;
            break;
          case 'PMM':
            isRequired = pscType.pmmApprovalRequired;
            break;
          case 'HRM':
            isRequired = pscType.hrmApprovalRequired;
            break;
          case 'ACCT':
            isRequired = pscType.acctReceivalRequired;
            break;
          case 'IT':
            isRequired = pscType.itReceivalRequired;
            break;
          default:
            isRequired = false;
            break;
        }
      }

      switch (isRequired) {
        case true:
          if (columnValue == null) {
            if (column != 'WS') {
              result = '#f2042c';
            }
            else {
              result = '#e5990b';
            }
            break;
          }
          else {
            result = 'transparent';
            break;
          }
        default:
          result = 'transparent';
          break;
      }
    }

    let ret = {};
    ret['background-color'] = result;
    return ret;

  }

  public formattedDate(d: Date) {
  let month = String(d.getMonth() + 1);
  let day = String(d.getDate());
  const year = String(d.getFullYear());

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return `${day}/${month}/${year}`;
}

}
